import { auth } from '../firebase/firebase';

const EVENTS_ENDPOINT = 'https://us-central1-futebol-cursos.cloudfunctions.net/metricsEndPoint/events';
const API_KEY = 'umachavealeatoriavaiaqui';
const SESSION_TIMEOUT = 30 * 60 * 1000;
const memory = new Map();
let queue = Promise.resolve();

function read(key) {
    try { return window.localStorage.getItem(key) || memory.get(key) || null; } catch { return memory.get(key) || null; }
}
function write(key, value) {
    memory.set(key, value);
    try { window.localStorage.setItem(key, value); } catch { /* Tracking remains optional. */ }
}
function identity() {
    let anonymousId = read('fc_anonymous_id');
    if (!anonymousId) { anonymousId = crypto.randomUUID(); write('fc_anonymous_id', anonymousId); }
    let session;
    try { session = JSON.parse(read('fc_visit_session_v2')); } catch { session = null; }
    if (!session?.id || !Number.isFinite(session.lastActivityAt) || !Array.isArray(session.linkedUids) || Date.now() - session.lastActivityAt >= SESSION_TIMEOUT) {
        session = { id: crypto.randomUUID(), startedAt: Date.now(), lastActivityAt: Date.now(), visitSent: false, linkedUids: [] };
    }
    session.lastActivityAt = Date.now();
    write('fc_visit_session_v2', JSON.stringify(session));
    return { anonymousId, session };
}
function skip() {
    return typeof window === 'undefined' || ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);
}
async function send(eventName, meta, ids, context, eventId = crypto.randomUUID(), at = context.at) {
    const user = context.user;
    const token = user ? await user.getIdToken() : null;
    const query = new URLSearchParams(context.search);
    const response = await fetch(EVENTS_ENDPOINT, {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/json', 'X-API-Key': API_KEY, ...(token ? { Authorization: `Bearer ${token}` } : {}) },
        body: JSON.stringify({
            event_id: eventId, event_name: eventName, uid: user?.uid || null,
            anonymous_id: ids.anonymousId, session_id: ids.session.id,
            ts: at, page_path: context.path, referrer: context.referrer,
            utm_source: query.get('utm_source'), utm_medium: query.get('utm_medium'), utm_campaign: query.get('utm_campaign'),
            meta: { ...meta, tracking_version: 2 },
        }),
    });
    const result = await response.json();
    if (!response.ok || result.ok !== true) throw new Error('Event collection unavailable');
}
async function collect(eventName, meta, context) {
    const ids = identity();
    if (!ids.session.visitSent) {
        await send('visit_started', {}, ids, context, `visit:${ids.session.id}`, ids.session.startedAt);
        ids.session.visitSent = true;
        write('fc_visit_session_v2', JSON.stringify(ids.session));
    }
    const uid = context.user?.uid;
    if (uid && !ids.session.linkedUids.includes(uid)) {
        await send('identity_linked', {}, ids, context, `identity:${ids.session.id}:${uid}`);
        ids.session.linkedUids.push(uid);
        write('fc_visit_session_v2', JSON.stringify(ids.session));
    }
    if (eventName) await send(eventName, meta, ids, context);
}
export function track(eventName, meta = {}) {
    if (skip()) return Promise.resolve();
    const context = { at: Date.now(), user: auth.currentUser, path: window.location.pathname, search: window.location.search, referrer: document.referrer || null };
    queue = queue.then(() => collect(eventName, meta, context)).catch(() => {
        console.warn('Não foi possível registrar a atividade de navegação.');
    });
    return queue;
}
export function observeVisit() { return track(null); }
